import { useState } from "react";
import { motion } from "framer-motion";
import { Download, Flame, Utensils } from "lucide-react";
import { API } from "@/lib/api";

export default function MenuSection({ content }) {
  const cats = content.menu || [];
  const [active, setActive] = useState(cats[0]?.id);
  const current = cats.find((c) => c.id === active) || cats[0];

  return (
    <section id="menu" className="relative py-24 md:py-36 bg-[#f9f6f0]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Nuestra carta</p>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight">El menú completo</h2>
          <a
            href={`${API}/menu/pdf`}
            data-testid="download-menu-btn"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#1a1a1a] text-white font-semibold px-8 py-4 transition-transform duration-200 hover:bg-black active:scale-95"
          >
            <Download size={18} /> Descargar menú en PDF
          </a>
        </div>

        {content.weekend_special && (
          <div data-testid="weekend-special" className="mb-10 flex items-center justify-center gap-3 rounded-2xl bg-[#da251d] text-white text-center px-6 py-5 shadow-[0_8px_30px_rgba(218,37,29,0.35)]">
            <Flame size={22} className="shrink-0" />
            <span className="font-display text-xl md:text-2xl font-semibold">{content.weekend_special}</span>
          </div>
        )}

        {/* Category tabs */}
        <div className="flex flex-wrap justify-center gap-2.5 mb-12 border-y border-stone-200 py-5">
          {cats.map((c) => (
            <button
              key={c.id}
              onClick={() => setActive(c.id)}
              data-testid={`menu-cat-${c.id}`}
              className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors duration-200 ${
                active === c.id ? "bg-[#da251d] text-white" : "bg-white text-[#57534e] border border-stone-200 hover:border-[#da251d]"
              }`}
            >
              {c.name}
            </button>
          ))}
        </div>

        {current && (
          <motion.div
            key={current.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="grid md:grid-cols-2 gap-x-14 gap-y-2"
          >
            {current.items.map((it) => (
              <div key={it.id} className="py-5 border-b border-dashed border-stone-300 flex gap-4 items-center">
                {it.image ? (
                  <img src={it.image} alt={it.name} loading="lazy" className="h-16 w-16 rounded-lg object-cover shrink-0 shadow-sm" data-testid={`menu-item-img-${it.id}`} />
                ) : (
                  <span className="h-16 w-16 rounded-lg bg-stone-100 flex items-center justify-center shrink-0 text-stone-300">
                    <Utensils size={20} />
                  </span>
                )}
                <div className="flex-1">
                  <h4 className="font-display text-xl font-semibold">{it.name}</h4>
                  {it.description && <p className="text-[#57534e] text-sm mt-1 leading-relaxed">{it.description}</p>}
                </div>
                <span className="font-semibold text-[#da251d] whitespace-nowrap">{it.price}</span>
              </div>
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
}
